export default __webpack_public_path__ + "static/media/AboutImage.9a449d85.jpeg";